import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from "./pages/EditPage.tsx";
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../config/rbac/actions.ts";

import {AddPage as AddProductPage} from '../application-products/pages/AddPage';
import {EditPage as EditProductPage} from '../application-products/pages/EditPage';


export const ApplicationsLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.ListApplications) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes(rbacActions.CreateApplication) ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/applications'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes(rbacActions.GetApplication) ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/applications'/>
                    )
                }

            >
            </Route>

            <Route
                path=':id/products/add'
                element={
                    allowedActions.includes(rbacActions.CreateApplicationProduct) ? (
                        <AddProductPage/>
                    ) : (
                        <Navigate to='/applications'/>
                    )
                }

            >
            </Route>

            <Route
                path=':id/products/:applicationProductId'
                element={
                    allowedActions.includes(rbacActions.UpdateApplicationProduct) ? (
                        <EditProductPage/>
                    ) : (
                        <Navigate to='/applications'/>
                    )
                }

            >
            </Route>

        </Routes>
    );
};
